import tzLookup from 'tz-lookup';
import { DEFAULT_TZ } from 'constants-activate';

export function getTimeZoneByGeoLocation({
  latitude,
  longitude,
}: {
  latitude?: number;
  longitude?: number;
}): string {
  if (latitude === undefined || longitude === undefined) {
    // need to return default when either latitude or longitude is undefined
    return DEFAULT_TZ;
  }

  try {
    return tzLookup(latitude, longitude);
  } catch {
    // need to default to something when tzLookup fails
    return DEFAULT_TZ;
  }
}
